import { render } from "./ReportFormHeader.vue?vue&type=template&id=b7e97b46&scoped=true"
import script from "./ReportFormHeader.vue?vue&type=script&lang=js"
export * from "./ReportFormHeader.vue?vue&type=script&lang=js"

import "./ReportFormHeader.vue?vue&type=style&index=0&id=b7e97b46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e97b46"]])

export default __exports__